import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "app/store";

// Define a type for the slice state
interface SpaceState {
  id: number;
}

// Define the initial state using that type
const initialState: SpaceState = {
  id: 0,
};

export const spaceSlice = createSlice({
  name: "space",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setId: (state, action: PayloadAction<number>) => {
      state.id = action.payload;
    },
  },
});

export const { setId } = spaceSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const getId = (state: RootState) => state.space.id;

export default spaceSlice.reducer;
